<template>
	<div class="wrapper-row item" :class="{ selected: selected }">
		<div
			class="fixed p-2 mr-2 icon"
			style="width: 130px; display: flex; align-items: center;"
		>
			<div class="wrapper-col" style="align-items: center;">
				<div style="display: flex; flex-grow: 1;">
					<I name="trophy2" class="h2" />
				</div>
				<div
					style="display: flex; font-size: 0.8em; flex-grow: 1;"
					class="name mt-2"
				>
					välj värde
				</div>
			</div>
		</div>
		<div style="flex: 1 0;" class="p-2">
			<div class="title p-1" style="">{{ title }}</div>
			<div class="wrapper-row">
				<div style="flex: 2 0;">
					<div class="name p-1">KALKYLRÄNTA</div>
					<div v-if="editable">
						<button style="width: 40px; height: 40px;" @click="$emit('dec')">
							-
						</button>
						<span
							style="text-align: center; border-top: 1px solid lightgray; border-bottom: 1px solid lightgray; min-width: 140px; height: 38px; display: inline-block;"
						>
							<span v-if="offset1 > 0" class="value p-1"
								>{{ (value1 * 100) | D1 }} + {{ offset1 }} %</span
							>
							<span v-else-if="offset1 < 0" class="value p-1"
								>{{ (value1 * 100) | D1 }} - {{ offset1 * -1 }} %</span
							>
							<span v-else class="value p-1">{{ value1 | P }}</span>
						</span>
						<button style="width: 40px; height: 40px;" @click="$emit('inc')">
							+
						</button>
					</div>
					<div v-else>
						<span v-if="offset1 > 0" class="value p-1"
							>{{ (value1 * 100) | D1 }} + {{ offset1 }} %</span
						>
						<span v-else-if="offset1 < 0" class="value p-1"
							>{{ (value1 * 100) | D1 }} - {{ offset1 * -1 }} %</span
						>
						<span v-else class="value p-1">{{ value1 | P }}</span>
					</div>
				</div>
				<div style="flex: 2 0;">
					<div class="name p-1">SCHABLONVÄRDE</div>
					<div class="value p-1">{{ value2 | D0 }} tkr</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* tslint:disable */

export default {
	name: "ValueSelection",
	props: ["selected", "title", "value1", "value2", "offset1", "editable"],
};
</script>

<style scoped lang="scss">
.wrapper-row {
	display: flex;
	flex-direction: row;
	background-color: col("colors.White");
}
.wrapper-col {
	display: flex;
	flex-grow: 1;
	flex-direction: column;
}
.fixed {
	flex-grow: 0;
	flex-shrink: 0;
}
.title {
	font-size: 1.5rem;
	font-weight: 600;
}
.name {
	font-size: 0.875rem;
	color: col("colors.DarkGrey");
	text-transform: uppercase;
	font-weight: 400;
}
.value {
	font-size: 1.25rem;
	font-weight: 400;
}

.selected .icon,
.selected .icon * {
	background-color: col("colors.Secondary");
	color: col("colors.White");
}

.selected {
	border-color: col("colors.Secondary");
}

/*.item:hover {*/
/*    border-color: #009bea;*/
/*    background-color: #009bea;*/
/*    cursor: pointer;*/
/*}*/
/*.item:hover * {*/
/*    color: white;*/
/*    background-color: #009bea;*/
/*}*/
</style>
